<div class="briefing-container">
  <div *ngIf="isFromMockTest || !assesmentData" class="loading-state">
    <div class="spinner"></div>
    <p>Loading assessment...</p>
  </div>

  <ng-container *ngIf="!isFromMockTest && assesmentData">
    <div class="briefing-content">
  <div class="main-card header-card">
    <div class="back-link">
      <ng-container *ngIf="
          assesmentData.logo_url || assesmentData.company_name;
          else defaultLogo
        ">
        <div class="company-brand-container">
          <img *ngIf="assesmentData.logo_url" [src]="getLogoUrl(assesmentData.logo_url)" alt="Company Logo"
            class="img-fluid company-logo" />
          <span class="company-name-text" *ngIf="assesmentData.company_name">
            {{ assesmentData.company_name }}
          </span>
        </div>
      </ng-container>
      <ng-template #defaultLogo>
        <img src="assets/images/BeExpert-logo (2).svg" class="img-fluid assesment-logo-img" />
      </ng-template>
    </div>
    <div class="tags">
      <span class="tag ongoing">Ongoing</span>
      <span class="tag proctored" *ngIf="assesmentData.is_proctored"><i class="bi bi-shield-check"></i> {{
        assesmentData.mode }}</span>
    </div>

    <h1>{{ assesmentData.quiz_name }}</h1>

    <p class="description">{{ assesmentData.description }}</p>
    <div class="stats-grid" *ngIf="assesmentData">
      <div class="stat-card">
        <div class="icon blue"><i class="bi bi-clock"></i></div>
        <div class="info">
          <p class="label">Duration</p>
          <p class="value">{{ convertToMinSec(assesmentData.time_limit) }}</p>
        </div>
      </div>
      <div class="stat-card">
        <div class="icon purple"><i class="bi bi-question-circle"></i></div>
        <div class="info">
          <p class="label">Questions</p>
          <p class="value">{{ assesmentData.total_questions }}</p>
        </div>
      </div>
      <div class="stat-card">
        <div class="icon green"><i class="bi bi-bullseye"></i></div>
        <div class="info">
          <p class="label">Passing</p>
          <p class="value">{{ assesmentData.passing_score }}%</p>
        </div>
      </div>
      <div class="stat-card">
        <div class="icon red"><i class="bi bi-arrow-repeat"></i></div>
        <div class="info">
          <p class="label">Attempts</p>
          <p class="value">{{ assesmentData.attempts_allowed }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="main-card rules-card">
    <div class="rules-header">
      <div class="rules-title-area">
        <h2>Rules & Instructions</h2>
        <p class="rules-subtitle">
          Please read carefully before starting your test.
        </p>
      </div>
      <button class="tips-btn"><i class="bi bi-lightbulb"></i> Tips</button>
    </div>

    <div class="rules-grid">
      <div class="rule-item"
        *ngIf="assesmentData?.is_proctored !== false && assesmentData?.proctoring_config?.enable_proctoring !== false && assesmentData?.proctoring_config?.detect_tab_switch !== false">
        <div class="icon-wrap purple-light"><i class="bi bi-window"></i></div>
        <div class="rule-text">
          <h4>Do not switch tabs</h4>
          <p>Switching tabs will be flagged as a violation.</p>
        </div>
      </div>
      <div class="rule-item">
        <div class="icon-wrap purple-light"><i class="bi bi-wifi"></i></div>
        <div class="rule-text">
          <h4>Stable internet required</h4>
          <p>A stable connection prevents auto-submission.</p>
        </div>
      </div>
      <div class="rule-item">
        <div class="icon-wrap purple-light"><i class="bi bi-clock"></i></div>
        <div class="rule-text">
          <h4>Complete within time</h4>
          <p>Timer cannot be paused once started.</p>
        </div>
      </div>
      <div class="rule-item">
        <div class="icon-wrap purple-light">
          <i class="bi bi-arrow-clockwise"></i>
        </div>
        <div class="rule-text">
          <h4>Do not refresh</h4>
          <p>Refreshing may submit your answers prematurely.</p>
        </div>
      </div>
      <div class="rule-item"
        *ngIf="assesmentData?.is_proctored !== false && assesmentData?.proctoring_config?.enable_proctoring !== false && assesmentData?.proctoring_config?.enable_camera !== false">
        <div class="icon-wrap purple-light"><i class="bi bi-camera"></i></div>
        <div class="rule-text">
          <h4>Camera ON (proctored)</h4>
          <p>Camera and mic must remain on during the test.</p>
        </div>
      </div>
      <div class="rule-item"
        *ngIf="assesmentData?.is_proctored !== false && assesmentData?.proctoring_config?.enable_proctoring !== false">
        <div class="icon-wrap purple-light">
          <i class="bi bi-camera-video"></i>
        </div>
        <div class="rule-text">
          <h4>Assessment will be recorded</h4>
          <p>Session recording is enabled for evaluation purposes.</p>
        </div>
      </div>
      <div class="rule-item"
        *ngIf="assesmentData?.is_proctored !== false && assesmentData?.proctoring_config?.enable_proctoring !== false && assesmentData?.proctoring_config?.detect_tab_switch !== false">
        <div class="icon-wrap purple-light">
          <i class="bi bi-arrows-angle-contract"></i>
        </div>
        <div class="rule-text">
          <h4>Do not minimize browser</h4>
          <p>
            Minimizing the assessment window may be treated as suspicious
            activity.
          </p>
        </div>
      </div>
      <div class="rule-item">
        <div class="icon-wrap purple-light">
          <i class="bi bi-slash-circle"></i>
        </div>
        <div class="rule-text">
          <h4>No external assistance</h4>
          <p>
            Use of phones, notes, AI tools, or help from others is prohibited.
          </p>
        </div>
      </div>
      <div class="rule-item"
        *ngIf="assesmentData?.is_proctored !== false && assesmentData?.proctoring_config?.enable_proctoring !== false">
        <div class="icon-wrap purple-light">
          <i class="bi bi-shield-check"></i>
        </div>
        <div class="rule-text">
          <h4>Allow required permissions</h4>
          <p>
            Grant camera, microphone, and screen-sharing permissions before
            starting.
          </p>
        </div>
      </div>
      <div class="rule-item"
        *ngIf="assesmentData?.is_proctored !== false && assesmentData?.proctoring_config?.enable_proctoring !== false">
        <div class="icon-wrap purple-light"><i class="bi bi-eye"></i></div>
        <div class="rule-text">
          <h4>Assessment is monitored</h4>
          <p>
            All activities are tracked and reviewed for fairness and integrity.
          </p>
        </div>
      </div>
    </div>
  </div>
  <!--  -->
  <div class="action-footer">
    <div class="checkbox-wrapper">
      <input type="checkbox" id="agree" [checked]="isChecked" (change)="toggleCheck()" />
      <label for="agree">I have read and understood all the instructions</label>
    </div>
    <button class="start-btn" [disabled]="!isChecked" (click)="startAssessment()">
      Start Assessment <i class="bi bi-arrow-right"></i>
    </button>
  </div>
  </div>
  </ng-container>
</div>

<!-- Proctoring Modal -->
<div class="modal-overlay" *ngIf="showProctoringModal">
  <div class="modal-container">
    <div class="modal-header">
      <div class="breadcrumb-nav">
        <ng-container *ngIf="skipRegistrationSteps; else showNormalFlow">
          <span [class.active]="currentStep === 3" [class.inactive]="currentStep !== 3"><span class="step-badge"
              *ngIf="currentStep === 3">1</span><span *ngIf="currentStep !== 3">1</span> Camera</span>
          <i class="bi bi-chevron-right"></i>
          <span [class.active]="currentStep === 4" [class.inactive]="currentStep !== 4"><span class="step-badge"
              *ngIf="currentStep === 4">2</span><span *ngIf="currentStep !== 4">2</span> Screen</span>
        </ng-container>
        <ng-template #showNormalFlow>
          <span [class.active]="currentStep === 1" [class.inactive]="currentStep !== 1"><span class="step-badge"
              *ngIf="currentStep === 1">1</span><span *ngIf="currentStep !== 1">1</span> Details</span>
          <i class="bi bi-chevron-right"></i>
          <span [class.active]="currentStep === 2" [class.inactive]="currentStep !== 2"><span class="step-badge"
              *ngIf="currentStep === 2">2</span><span *ngIf="currentStep !== 2">2</span> Verify</span>
          <i class="bi bi-chevron-right"></i>
          <span [class.active]="currentStep === 3" [class.inactive]="currentStep !== 3"><span class="step-badge"
              *ngIf="currentStep === 3">3</span><span *ngIf="currentStep !== 3">3</span> Camera</span>
          <i class="bi bi-chevron-right"></i>
          <span [class.active]="currentStep === 4" [class.inactive]="currentStep !== 4"><span class="step-badge"
              *ngIf="currentStep === 4">4</span><span *ngIf="currentStep !== 4">4</span> Screen</span>
        </ng-template>
      </div>
      <button class="close-btn" (click)="closeModal()">
        <i class="bi bi-x"></i>
      </button>
    </div>

    <!-- Step 1: Details -->
    <ng-container *ngIf="currentStep === 1">
      <form [formGroup]="assesmentForm">
        <div class="modal-title-section">
          <div class="icon-box purple-bg">
            <i class="bi bi-person"></i>
          </div>
          <div class="text-content">
            <h3>Your Details</h3>
            <p>We'll send a verification code to your email</p>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label>First name <span class="req">*</span></label>
            <input type="text" formControlName="first_name" placeholder="John" class="form-input" />
            <small class="text-danger smaller-text" *ngIf="
                assesmentForm.get('first_name')?.errors?.['required'] &&
                assesmentForm.get('first_name')?.touched
              ">
              First name is required</small>
          </div>
          <div class="form-group">
            <label>Last name <span class="req">*</span></label>
            <input type="text" formControlName="last_name" placeholder="Doe" class="form-input" />
            <small class="text-danger smaller-text" *ngIf="
                assesmentForm.get('last_name')?.touched &&
                assesmentForm.get('last_name')?.errors?.['required']
              ">Last name is required
            </small>
          </div>
        </div>

        <div class="form-group full-width">
          <label>Email address <span class="req">*</span></label>
          <input type="email" formControlName="email" placeholder="you@example.com" class="form-input" />
          <small class="text-danger smaller-text" *ngIf="
              assesmentForm.get('email')?.touched &&
              assesmentForm.get('email')?.errors?.['email']
            ">
            Enter a valid email address</small>
        </div>

        <div class="form-group full-width">
          <label>Phone number <span class="req">*</span></label>
          <div class="phone-input-group">
            <div class="country-code">
              <span>IN +91</span>
              <i class="bi bi-chevron-down"></i>
            </div>
            <input type="tel" formControlName="phone" placeholder="98765 43210" class="form-input phone-input"
              maxlength="10" />
          </div>

          <small class="text-danger smaller-text" *ngIf="
              assesmentForm.get('phone')?.touched &&
              assesmentForm.get('phone')?.errors?.['required']
            ">
            Phone number is required
          </small>

          <small class="text-danger smaller-text" *ngIf="
              assesmentForm.get('phone')?.touched &&
              assesmentForm.get('phone')?.errors?.['pattern']
            ">
            Enter valid 10-digit mobile number
          </small>
        </div>
      </form>

      <button class="allow-btn send-code-btn" (click)="postAssesmentRegister()">
        Send Verification Code
      </button>
    </ng-container>

    <!-- Step 2: Verification -->
    <ng-container *ngIf="currentStep === 2">
      <div class="modal-title-section">
        <div class="icon-box purple-bg">
          <i class="bi bi-envelope"></i>
        </div>
        <div class="text-content">
          <h3>Verify your email</h3>
          <p>
            Enter the 6-digit code sent to
            <strong class="uppercase-email">{{ userEmail }}</strong>
          </p>
        </div>
      </div>

      <div class="verification-code-container">
        <input *ngFor="
            let digit of verificationCode;
            let i = index;
            trackBy: trackByIndex
          " type="text" maxlength="1" [id]="'code-' + i" [(ngModel)]="verificationCode[i]"
          (input)="onCodeInput($event, i)" (keydown)="onCodeKeydown($event, i)" (paste)="onCodePaste($event, i)"
          class="code-input" />
      </div>

      <div class="verification-actions">
        <a href="javascript:void(0)" class="edit-details-link" (click)="editDetails()">← Edit details</a>
        <span class="resend-text" *ngIf="otpTimer > 0">
          Resend in {{ otpTimer }}s
        </span>

        <a *ngIf="otpTimer === 0" href="javascript:void(0)" class="resend-link" [class.disabled]="isResendingOtp"
          (click)="resendOtp()">
          {{ isResendingOtp ? "Sending..." : "Resend OTP" }}
        </a>
      </div>

      <button class="allow-btn verify-btn" (click)="postAssesmentOtp()">
        Verify & Continue
      </button>
    </ng-container>

    <!-- Step 3: Camera & Mic -->
    <ng-container *ngIf="currentStep === 3">
      <div class="modal-title-section">
        <div class="icon-box">
          <i class="bi bi-camera"></i>
        </div>
        <div class="text-content">
          <h3>Camera & Microphone</h3>
          <p>Required for proctored testing</p>
        </div>
      </div>

      <div class="video-placeholder" *ngIf="!cameraAccessGranted">
        <i class="bi bi-camera"></i>
      </div>

      <div class="video-preview-container" *ngIf="cameraAccessGranted">
        <video [srcObject]="cameraStream" autoplay muted playsinline></video>
      </div>

      <div class="status-cards">
        <div class="status-card">
          <div class="status-info">
            <i class="bi bi-camera"></i>
            <span>Camera</span>
          </div>
          <span class="status-badge" [ngClass]="cameraAccessGranted ? 'granted' : 'pending'">{{ cameraAccessGranted ?
            "Granted" : "Pending" }}</span>
        </div>
        <div class="status-card">
          <div class="status-info">
            <i class="bi bi-mic"></i>
            <span>Microphone</span>
          </div>
          <span class="status-badge" [ngClass]="cameraAccessGranted ? 'granted' : 'pending'">{{ cameraAccessGranted ?
            "Granted" : "Pending" }}</span>
        </div>
      </div>

      <p class="info-text" *ngIf="!cameraAccessGranted">
        <strong>Camera access is mandatory</strong> to start the test. Please
        allow access when prompted.
      </p>

      <p class="info-text" *ngIf="cameraAccessGranted">
        Camera and microphone access granted successfully.
      </p>

      <button class="allow-btn" *ngIf="!cameraAccessGranted" (click)="allowAccess()">
        Allow Access
      </button>
      <button class="allow-btn" *ngIf="cameraAccessGranted" (click)="goToScreenShare()">
        Continue to Screen Share
      </button>
    </ng-container>

    <!-- Step 4: Screen Share -->
    <ng-container *ngIf="currentStep === 4">
      <!-- Normal View -->
      <ng-container *ngIf="!screenShareError">
        <div class="modal-title-section">
          <div class="icon-box">
            <i class="bi bi-display"></i>
          </div>
          <div class="text-content">
            <h3>Share Your Entire Screen</h3>
            <p>Choose "Entire Screen" — not a tab or window</p>
          </div>
        </div>

        <div class="dashed-box">
          <div class="screen-icon">
            <i class="bi bi-display"></i>
          </div>
          <h4>Entire Screen Required</h4>
          <p>BeExpert will record your screen during the test.</p>
        </div>

        <div class="warning-banner">
          <i class="bi bi-exclamation-triangle"></i>
          <p>
            <strong>Do not stop sharing</strong> during the test. It will be
            flagged as a violation.
          </p>
        </div>

        <div class="modal-footer-btns">
          <button class="cancel-btn" (click)="cancelScreenShare()">
            Cancel
          </button>
          <button class="allow-btn share-btn" (click)="shareScreen()">
            Share Screen
          </button>
        </div>
      </ng-container>

      <!-- Error View -->
      <ng-container *ngIf="screenShareError">
        <div class="modal-title-section error-title">
          <div class="icon-box error-icon-box">
            <i class="bi bi-exclamation-triangle"></i>
          </div>
          <div class="text-content">
            <h3 class="error-text">Screen sharing required</h3>
            <p>Action required to continue</p>
          </div>
        </div>

        <div class="error-box">
          <h4 class="error-text">
            Screen sharing is required to continue the assessment.
          </h4>
          <p>
            You cancelled the screen share request. Without it, your test cannot
            start. This event has been logged as a violation.
          </p>
        </div>

        <div class="modal-footer-btns single-btn">
          <button class="allow-btn share-btn" (click)="shareScreen()">
            Share Screen
          </button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>